import React, { useState, useEffect } from 'react';
import './App.css'; // if you have a CSS file for styling
import logo from './images/logo.png';
function App() {
  const [activeContent, setActiveContent] = useState('home'); // 'home' or 'privacy'
  useEffect(() => {
    // Function to set active content based on URL hash
    const handleHashChange = () => {
      const hash = window.location.hash;

      if (hash === '#privacy') {
        setActiveContent('privacy');
      } else {
        setActiveContent('home');
      }
    };

    // Set initial content based on URL hash
    handleHashChange();

    // Add event listener for hashchange
    window.addEventListener('hashchange', handleHashChange);

    // Cleanup the event listener on unmount
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  return (
    <div className="App" style={{maxWidth: 1024, justifyContent:'center', alignItems: 'center', marginLeft: 'auto', marginRight: 'auto'} }>
      <header className="App-header">
        <nav>
          <ul>
            <li>
              <a 
                href="#" 
                className={activeContent === 'home' ? 'active' : ''} 
                onClick={(e) => { 
                  e.preventDefault(); 
                  setActiveContent('home'); 
                }}
              >
                Home
              </a>
            </li>
            <li>
              <a 
                href="#privacy" 
                className={activeContent === 'privacy' ? 'active' : ''} 
                onClick={(e) => { 
                  e.preventDefault(); 
                  setActiveContent('privacy'); 
                }}
              >
                Privacy
              </a>
            </li>
          </ul>
        </nav>
      </header>
      

      {activeContent === 'home' && (
        <div id="homeContent">
          <section id="our-mission">
            <h2>OUR MISSION</h2>
            <p>Viwat - វិវឌ្ឍន៍ is an E-commerce enabler that provides end-to-end solution for brands to succeed online, by providing an integrated end-to-end solution for online commerce covering all digital channels – online marketplaces, mono- & multi-brand sites, and social commerce. 
            Our integrated full suite of services span strategy, multi-channel store creation & operations, performance marketing, full supply chain management including regulatory and importation matters, demand-planning, data analytics, and customer service.</p>
            <h2>What You Will Do:</h2>
            <li>Create and publish brand contents on all social media platforms including LinkedIn, Twitter, Instagram and Facebook</li>
            <li>  Leverage and monitor our/partners’ marketplace</li>
            <li>  Support the creation of a social media strategy through competitive research, platform determination, messaging, and audience identification</li>
            <li>  Write original copy and support with company blog content</li>
            <li>  Stay up to date with the latest social media best practices and technologies</li>
            <li>  Report on social media performance and metrics to determine trends and key findings</li>
            <li>  Collaborate with internal teams such as PR and Communications, as well as external partners to manage employee value proposition communications</li>
            Your Qualifications: 
            <h1>At Viwat - វិវឌ្ឍន៍</h1><span> we value the experiences that individual team members add to our culture. Please do not hesitate to apply even if you do not meet the exact qualifications, we look forward to learning more about you!</span>
            <li>Excellent writing, editing (photo/video/text), presentation and communication skills </li>
            <li>Proven ability to analyze and report on measurable results</li>
            <li>Passion for storytelling and everything social media</li>
        </section>

          <h2>OUR VISION</h2>
          
            <li>To help businesses grow both on and offline</li>
            <li>To foster talented leaders</li>
            <li>To build convenient systems and to better connect Cambodia</li>
          

          <h3>About us</h3>
          <h4>Viwat</h4>
          <p>
          Viwat is a Leader in Cambodian Logistics with the most advanced app platform. We aggregate and provide real-time delivery data updates to our users. We've consolidated over 300,000 in sale transactions by connecting our users to national delivery solutions.
          </p>
          
          <h4>Call Us</h4>
          <p>+855 86 880 980</p>
          <h4>Facebook</h4>
          <p><a href='https://www.facebook.com/viwat2u'>viwat2u</a></p>
          <h4>Telegram</h4>
          <p><a href='https://t.me/Viwat_Express'>viwat2u</a></p>
        
        </div>
      )}

      {activeContent === 'privacy' && (
        <div id="privacyContent">
           <h2>Privacy</h2>
          <p>Viwat is committed to protecting the privacy of all users of our website viwat.com, or mobile applications (together, the "Sites"). Please read this Privacy Policy and understand it before using our services. By visiting and/or ordering services on this Website, you agree and, where required, consent to the collection, use and transfer of your information as set out in this policy. This Privacy Policy applies to our information collection.</p>

          <h3>Contact Details</h3>
          <p>If you have any queries or requests concerning this privacy policy or how we handle your data more generally, please get in touch with us using the following details. By contacting our general customer services team at: info@viwat.com</p>

          <h3>How we collect your information</h3>
          <p>We collect your personal information when you interact with us or use our services, such as when you use our Sites to place an order. We also look at how visitors use our Sites, to help us improve our services and optimize customer experience.</p>
          <ul>
              <li>when you create an account with us or you change your account settings;</li>
              <li>when you place an order with us and during the order process (including for payment and order delivery);</li>
              <li>when you contact us directly via email, phone, post, message or via our chat function;</li>
              <li>and when you browse and use our Sites (before and after you create an account with us).</li>
          </ul>
          <p>We also collect information from third party sites, such as advertising platforms and our fraud detection provider. When you visit the Sites or use a Viwat service through the Sites, you are asked to provide information about yourself including your name, contact details, delivery address. We also collect information about your usage of the Sites and information about you from any messages you post to the Sites or when you contact us or provide us with feedback, including via e-mail, letter, phone or chat function. If you contact us by phone, we record the call for training and service improvement purposes, and make notes in relation to your call. We collect technical information from your mobile device or computer, such as its operating system, the device and connection type and the IP address from which you are accessing our Sites.</p>

          <h3>Changes to our Privacy Policy</h3>
          <p>Viwat reserves the right to alter all or any part of this Privacy Policy. Any changes thereto will be notified via the Website and, where appropriate, through e-mail notification.</p>

          <h3>Other Websites</h3>
          <p>Our Website may have links to other websites. This privacy policy only applies to the Website. You should therefore read the privacy policies of the other websites when you are using those sites.</p>  
        </div>
      )}

    <footer>
        <img src={logo} alt="Viwat Logo"  style={{ height: 45 }} /> {/* replace with your logo path */}
      </footer>
    </div>
    
  );
}

export default App;
